import * as types from './actionsTypes';

export type SaveHadasimActionType = {
  type: string;
  kind: string;
  price: string | number;
  headers: any;
  onSuccess?: () => void;
};

export const saveHadasimAction = (
  kind: string,
  price: string | number,
  headers: any,
  onSuccess?: () => void
): SaveHadasimActionType => ({
  type: types.SAVE_NEW_HADASIM,
  kind,
  price,
  headers,
  onSuccess,
});
